module.exports = __webpack_public_path__ + "static/media/qr-code-light.600e336a.svg";